import { Component, forwardRef, Input, OnChanges, OnInit, SimpleChange } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from '../../../../main/maintenances/i18n/en.json';
import spanish from '../../../../main/maintenances/i18n/es.json';
import portuguese from '../../../../main/maintenances/i18n/pt.json';

import { Problem } from '../../../interfaces';

export function ValidateAutocomplete(): { required: boolean } {
  return { required: true };
}

const INPUT_FIELD_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ProblemsComponent),
  multi: true
};

@Component({
  selector: 'problems',
  templateUrl: './problems.component.html',
  styleUrls: ['./problems.component.scss'],
  providers: [INPUT_FIELD_VALUE_ACCESSOR]
})
export class ProblemsComponent implements ControlValueAccessor, OnInit, OnChanges {
  @Input() required: boolean;
  @Input() disabled: boolean;
  @Input() hint: boolean;
  @Input() floatLabel: boolean;
  @Input() appearance = 'outline';

  @Input() segmentId: string;
  @Input() equipmentTypeId: string;

  @Input() public problems: Problem[] = [];
  public inputValue = new FormControl();
  public selectedProblem: Problem;
  public loading = false;

  constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({english, portuguese, spanish});
    if (this.required) { this.inputValue.setValidators(ValidateAutocomplete); }
  }

  ngOnInit(): void {
    if (this.disabled) { this.inputValue.disable(); }
  }

  ngOnChanges(changes: { [property: string]: SimpleChange }): void {
    for (const propertyName in changes) {
      if (propertyName === 'disabled') {
        const disabledValue = changes[propertyName].currentValue;
        if (disabledValue) {
          this.inputValue.disable();
        } else {
          this.inputValue.enable();
        }
      }
    }
  }

  onChange: (_: any) => void = () => { };
  onTouched: (_: any) => void = () => { };

  writeValue(problemId: any): void {
    if (problemId) {
      this.selectedProblem = this.problems.find((problem) => problem.id === problemId);
      this.inputValue.setErrors(null);
    } else {
      this.unselectProblem();
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setSelectedProblem(): void {
    if (this.inputValue.value) {
      this.selectedProblem = this.problems.find((problem) => problem.id === this.inputValue.value);
      this.onChange(this.inputValue.value);
      this.inputValue.setErrors(null);
    }
  }

  unselectProblem(): void {
    this.onChange(null);
    this.inputValue.setValue(null);
    this.selectedProblem = null;
    this.inputValue.setErrors(null);
  }
}
